import { RAISE_QUERY_URL } from "constants/endpoints";
import { get } from "services/api";

export const queryBrands = async ({ keywords }) => {
  const resp = await get(
    `${RAISE_QUERY_URL}?type=brands&keywords=${encodeURIComponent(
      keywords
    )}&isCms=false`
  );
  return resp.data;
};
